// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.userData_case {
    display: flex;
    flex-direction: column;
    background-color: var(--bg-card);
    padding: 20px;
    border-radius: 15px;
    gap: 15px;
    border: 1px solid var(--border);
    box-shadow: var(--shadow-sm);
}

.user_doc_title {
    margin: 0 0 20px 0;
    font-size: 22px;
    font-weight: bold;
}

.userData_features {
    display: flex;
    flex-direction: row;
    justify-content: start;
    gap: 200px;
    align-items: center;
    background-color: var(--bg-card);
    padding: 20px;
    border-radius: 15px;
    border: 1px solid var(--border);
    box-shadow: var(--shadow-sm);
}

.userData_box {
    display: flex;
    flex-direction: column;
    gap: 7px;
}

.userData_update_features {
    background-color: var(--primary);
    padding: 15px 30px;
    border-radius: 5px;
    border: none;
    outline: none;
    cursor: pointer;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/pages/users/userById/UserSections/UserFeatures/userFeatures.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,+BAA+B;IAC/B,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,mBAAmB;IACnB,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,+BAA+B;IAC/B,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf","sourcesContent":[".userData_case {\n    display: flex;\n    flex-direction: column;\n    background-color: var(--bg-card);\n    padding: 20px;\n    border-radius: 15px;\n    gap: 15px;\n    border: 1px solid var(--border);\n    box-shadow: var(--shadow-sm);\n}\n\n.user_doc_title {\n    margin: 0 0 20px 0;\n    font-size: 22px;\n    font-weight: bold;\n}\n\n.userData_features {\n    display: flex;\n    flex-direction: row;\n    justify-content: start;\n    gap: 200px;\n    align-items: center;\n    background-color: var(--bg-card);\n    padding: 20px;\n    border-radius: 15px;\n    border: 1px solid var(--border);\n    box-shadow: var(--shadow-sm);\n}\n\n.userData_box {\n    display: flex;\n    flex-direction: column;\n    gap: 7px;\n}\n\n.userData_update_features {\n    background-color: var(--primary);\n    padding: 15px 30px;\n    border-radius: 5px;\n    border: none;\n    outline: none;\n    cursor: pointer;\n    font-size: 16px;\n    font-weight: 600;\n    color: #fff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
